/**
 * useCurrentUserId — resolves the authenticated user's Id<"users"> for
 * the `<SubscriptionScope key={userId}>` binding (FR-009).
 *
 * Wraps `useQuery(api.users.getMe)` and extracts `_id`. Returns `null`
 * when the query has not resolved yet or the user is unauthenticated.
 */
import { useQuery } from "convex/react";
import { api } from "../../../../../convex/_generated/api";
import type { Id } from "../../../../../convex/_generated/dataModel";

/**
 * Named hook returning the current user's Convex `Id<"users">`, or `null`
 * when the auth state has not resolved.
 *
 * The returned value is used as a React `key` on `<SubscriptionScope>`
 * to force full teardown/remount on user change.
 */
export function useCurrentUserId(): Id<"users"> | null {
  const me = useQuery(api.users.getMe);
  return me?._id ?? null;
}
